<template>
  <once-off-modal
    :cookie-name="cookieName"
    :last-updated="lastUpdated"
    :open-on-mount="false"
    :remove-cookie="removeCookie"
    :action-required="actionRequired"
  >
    <template #modal-content>
      <slot name="modal-content" :closeModal="closeModal" />
    </template>
  </once-off-modal>
</template>

<script setup>
import OnceOffModal from '../OnceOffModal/OnceOffModal.vue';
import { ref, provide, onMounted } from 'vue';
import { useCookies } from '../../hooks/useCookies';
import Browserslist from 'browserslist';

const isOpen = ref(false);
const canBeOpened = ref(true);
const { getCookie, setCookie, expireCookie } = useCookies();
const cookieIsSaveable = ref(false);

provide('injectedIsOpen', isOpen);

const props = defineProps({
  cookieName: {
    type: String,
    default: '',
  },
  lastUpdated: {
    type: String,
    default: '',
  },
  openOnMount: {
    type: Boolean,
    default: true,
  },
  removeCookie: {
    type: Boolean,
    default: false,
  },
  actionRequired: {
    type: Boolean,
    default: false,
  },
});

function getBrowserInfo() {
  const userAgent = navigator.userAgent.toLowerCase();

  console.log(userAgent);

  var browserName, browserVersion;

  if (userAgent.indexOf('trident/') !== -1) {
    browserName = 'IE';
  } else if (userAgent.indexOf('chrome') !== -1 || userAgent.indexOf('crios') !== -1) {
    const chromeRegex = /(chrome|crios)\/(\d+\.\d+\.\d+\.\d+)/;
    const matches = userAgent.match(chromeRegex);
    if (matches) {
      browserName = 'chrome';
      browserVersion = matches[2];
    }
  } else if (userAgent.indexOf('firefox') !== -1 || userAgent.indexOf('fxios') !== -1) {
    const firefoxRegex = /(firefox|fxios)\/(\d+\.\d+)/;
    const matches = userAgent.match(firefoxRegex);
    if (matches) {
      browserName = 'firefox';
      browserVersion = matches[2];
    }
  } else if (userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1) {
    const safariRegex = /version\/(\d+\.\d+)/;
    const matches = userAgent.match(safariRegex);
    if (matches) {
      browserName = 'safari';
      browserVersion = matches[1];
    }
  } else if (userAgent.indexOf('edge') !== -1 || userAgent.indexOf('edgios') !== -1) {
    const edgeRegex = /(edge|edgios)\/(\d+\.\d+)/;
    const matches = userAgent.match(edgeRegex);
    if (matches) {
      browserName = 'edge';
      browserVersion = matches[2];
    }
  }

  return {
    name: browserName,
    version: browserVersion,
  };
}

const isBrowserVersionSupported = (browserVersions, browser, version) => {
  let isSupported = false;
  for (var i = 0; i < browserVersions.length; i++) {
    const versionInfo = browserVersions[i].split(' ');

    const browserName = versionInfo[0];

    const browserVersion = parseInt(versionInfo[1]);

    if (browserName === browser) {
      if (version >= browserVersion) {
        isSupported = true;
      }
    }
  }
  return isSupported;
};

onMounted(() => {
  const { cookieName, lastUpdated, removeCookie } = props;
  const cookie = getCookie(props.cookieName);

  if (removeCookie && cookieName) {
    expireCookie(cookieName);
  }

  if (cookie && cookie === props.lastUpdated) {
    canBeOpened.value = false;
    return;
  }

  if (cookieName && lastUpdated && cookieName !== '' && lastUpdated !== '') {
    cookieIsSaveable.value = true;
  } else {
    return;
  }

  if (cookieName !== '' && lastUpdated !== '' && cookie !== props.lastUpdated) {
    expireCookie(cookieName);
  }

  if (canBeOpened.value === true) {
    const targetBrowsers = Browserslist('last 2 versions');

    const browserInfo = getBrowserInfo();

    const isSupported = isBrowserVersionSupported(
      targetBrowsers,
      browserInfo.name,
      parseInt(browserInfo.version),
    );

    if (!isSupported) {
      isOpen.value = true;
    }
  }
});

const closeModal = (e) => {
  isOpen.value = false;

  let expirationDate = new Date();
  expirationDate.setFullYear(expirationDate.getFullYear() + 10);

  setCookie(props.cookieName, expirationDate, props.lastUpdated);
};
</script>
